var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0733 0.927002H7.70424C3.20024 0.927002 0.515167 3.61208 0.515167 8.11607V18.4728C0.515167 22.9892 3.20024 25.6742 7.70424 25.6742H18.061C22.5649 25.6742 25.25 22.9892 25.25 18.4852V8.11607C25.2624 3.61208 22.5773 0.927002 18.0733 0.927002ZM18.8034 10.4547L11.7875 17.4705C11.6143 17.6438 11.3792 17.7427 11.1317 17.7427C10.8843 17.7427 10.6492 17.6438 10.4759 17.4705L6.97419 13.9688C6.61536 13.61 6.61536 13.016 6.97419 12.6572C7.33303 12.2984 7.92696 12.2984 8.2858 12.6572L11.1317 15.5031L17.4918 9.14308C17.8506 8.78425 18.4445 8.78425 18.8034 9.14308C19.1622 9.50192 19.1622 10.0835 18.8034 10.4547Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.87cb3d00e2f31c99e0ffc69581dffe75.svg";
export { ForwardRef as ReactComponent };